import { Component } from '@angular/core';
import { IonicPage, ViewController } from 'ionic-angular';
import { SettingsProvider } from '../../providers/settings/settings';

/**
 * Generated class for the TermsAndConditionsPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-terms-and-conditions',
  templateUrl: 'terms-and-conditions.html',
})
export class TermsAndConditionsPage {

  constructor(private settings: SettingsProvider, private viewCtrl: ViewController) {
  }

  accept() {
    this.viewCtrl.dismiss(<UserConsentResult>{acceptedAnalytics:true});
  }

  reject() {
    this.viewCtrl.dismiss(<UserConsentResult>{acceptedAnalytics:false});
  }
}

export interface UserConsentResult {
  acceptedAnalytics: boolean;
}


// WEBPACK FOOTER //
// ./src/pages/terms-and-conditions/terms-and-conditions.ts